import { IViewModel } from '../../interfaces/view-model.interface';

export class NotificationTemplate implements IViewModel {
    // Define primitive properties.
    // Key.
    public id: number = 0;

    public name: string;

    public category: string;
    public templateType: string;
    public format: string;
    public notificationType: string;

    public notificationText: string;

    // https://maxjira.max.gov/browse/VNEXT-2269:  added the following attributes to support user-defined template.
    public formTemplateId: number;
    public isUserDefined: boolean;
    public associatedNotificationText: string; // Note:  used for the subject part of an email template that consists of an email subject and body.

    // notificationText can be a | delimited string to allow presentation of summary information in a grid/list
    // this method returns either the first part of the text (or all of it if there's no pipe)
    public getFirstPartOfNotificationText(): string {
        return this.notificationText.split("|")[0];
    }

    // returns all parts of the notification text so the caller can iterate them/concatenate them as needed
    public getAllTextParts(): string[] {
        return this.notificationText.split('|');
    }

    // cloneSelf():  make a copy of a notification template.
    public cloneSelf(): NotificationTemplate {
        let clone: NotificationTemplate = new NotificationTemplate();

        clone.id = this.id;
        clone.name = this.name;

        clone.category = this.category;
        clone.templateType = this.templateType;
        clone.format = this.format;
        clone.notificationType = this.notificationType;

        clone.notificationText = this.notificationText;
        clone.associatedNotificationText = this.associatedNotificationText;

        clone.formTemplateId = this.formTemplateId;
        clone.isUserDefined = this.isUserDefined;

        return clone;
    }
}
